import { render, staticRenderFns } from "./u-language-items-text.vue?vue&type=template&id=451d012c&scoped=true"
import script from "./u-language-items-text.vue?vue&type=script&lang=js"
export * from "./u-language-items-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451d012c",
  null
  
)

export default component.exports